module.exports = __webpack_public_path__ + "img/nationaltrust.70ea07a.png";